import { createSlice } from '@reduxjs/toolkit'

const initialProgramsState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: [],
	programForEdit: undefined,
	lastError: null,
}
export const callTypes = {
	list: 'list',
	action: 'action',
}

export const programsSlice = createSlice({
	name: 'programs',
	initialState: initialProgramsState,
	reducers: {
		catchError: (state, action) => {
			state.error = action.payload.error
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false
			} else {
				state.actionsLoading = false
			}
		},
		startCall: (state, action) => {
			state.error = null
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true
			} else {
				state.actionsLoading = true
			}
		},
		// getProgramById
		programFetched: (state, action) => {
			state.actionsLoading = false
			state.programForEdit = action.payload.data
			state.error = null
		},
		// findPrograms
		programsFetched: (state, action) => {
			const { totalCount, entities } = action.payload
			state.listLoading = false
			state.error = null
			state.entities = entities
			state.totalCount = totalCount
		},
		// createProgram
		programCreated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			state.entities.push(action.payload.data)
		},
		// updateProgram
		programUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.map((entity) => {
				if (entity.id === action.payload.program.id) {
					return action.payload.program
				}
				return entity
			})
		},
		// updateStatus
		statusUpdated: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.programForEdit.status = action.payload.status
		},
		// deleteProgram
		programDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => el.id !== action.payload.id,
			)
		},
		// deletePrograms
		programsDeleted: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.entities = state.entities.filter(
				(el) => !action.payload.ids.includes(el.id),
			)
		},
		// deletePrograms
		courseRemoved: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.programForEdit.courses = state.programForEdit.courses.filter(
				(el) => el.id !== action.payload.course_id,
			)
		},
		// deletePrograms
		courseAdded: (state, action) => {
			state.error = null
			state.actionsLoading = false
			state.programForEdit.courses.push(action.payload.course)
		},
		// programsUpdateState
		programsStatusUpdated: (state, action) => {
			state.actionsLoading = false
			state.error = null
			const { ids, status } = action.payload
			state.entities = state.entities.map((entity) => {
				if (ids.findIndex((id) => id === entity.id) > -1) {
					entity.status = status
				}
				return entity
			})
		},
	},
})
